<template>
  <div
    class="d-flex flex-column align-items-center justify-content-center flex-grow-1"
  >
    <div class="text-center">
      <font-awesome-icon
        :icon="['far', 'exclamation-triangle']"
        size="3x"
        class="mb-4 text-danger"
      />
      <p>
        {{ $t("not_found.message") }}
      </p>
    </div>
  </div>
</template>

<script>

export default {
  name: '404-Page',
}
</script>
